import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Join class names, letting a later utility win over an earlier one that sets
 * the same property.
 *
 * Plain `clsx` would emit `px-6 px-4` and leave the winner to source order in
 * the generated stylesheet rather than to the caller, which is how a component
 * ends up unable to override its own default padding from a prop.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
